import Remote from "./remote_controller"

export default class extends Remote {
  replaceOuter (event) {
    super.replaceOuter(event)

    new FlashMessage(event.currentTarget.dataset.notice, 'success')
  }
}
